// @flow
import axios from "../axios";

export const getClientDetails = async () => {
    
  return await axios.get(`/api/client`)
}


// WEBPACK FOOTER //
// ./src/utils/api/client.js